// user action types
import { UserActionType } from "../../types/store.types";

// user action types
export const USER_ACTION_TYPES : UserActionType = {
    SET_CURRENT_USER: 'SET_CURRENT_USER',
  };